angular.module('FlexyBeautyApp.controllers').controller('BooksyCtrl',
    ["$scope", "$sce", "SiteData", "Brand",
        function ($scope, $sce, SiteData, Brand) {
            $scope.dd = {
                booksyUrl: null
            };

            $scope.init = function () {
                $scope.getBooksyUrl();
            };

            $scope.getBooksyUrl = function () {
                if ($scope.dd.booksyUrl === null) {
                    const owner = $scope.ad.loggedUser;
                    if (owner) {
                        let booksyUrl = $scope.ad.addons.sub.booksyButtonAccess ? Brand.url.booksyUrl : Brand.url.discoverBooksyUrl;
                        const companyCode = owner.company ? owner.company.code : null;
                        booksyUrl += '?id=' + companyCode;
                        if (!$scope.ad.addons.sub.booksyButtonAccess) {
                            booksyUrl += '&c=' + $scope.ad.loggedUser.company.country;
                        }
                        $scope.dd.booksyUrl = $sce.trustAsResourceUrl(booksyUrl);
                    }
                }
            };

            $scope.init();
        }
    ]);



// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/BooksyCtrl.js